import { useState } from "react";

const useTrigger = (
  defaultValue = false
): [boolean, () => void, () => void] => {
  const [value, setValue] = useState(defaultValue);

  const on = () => setValue(true);
  const off = () => setValue(false);

  return [value, on, off];
};

export default useTrigger;
